import React from 'react';
import { RenderModule } from 'holocron';
import PropTypes from 'prop-types';
import SampleCards from './SampleCards';
import styles from './card.scss';

const Cmv = (props) => (
  <>
    <RenderModule moduleName="axp-global-header" />
    <div data-testid="header-ribbon" className={`${styles.samSize}`}>
      <div className="width-full container">
        <div className="col-sm-2 col-md-2 col-lg-2 pull-right-md-up">
          <img
            src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/brand/ribbon-member_since-brightblue.svg"
            alt="ribbon-member_since-brightblue"
          />
          <p className="text-align-center">2023</p>
        </div>
      </div>
    </div>
    <div className="container">
      <div data-testid="topcards-container" id="contents" className="margin-2-b">
        <RenderModule moduleName="axp-global-rewards-nav" props={props} />
      </div>
      <RenderModule moduleName="axp-rewards-use-points" props={props} />
      <SampleCards />
    </div>
    <RenderModule data-testid="axp-footer" moduleName="axp-footer" />
  </>
);

Cmv.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      props: PropTypes.shape({
        programType: PropTypes.string,
      }),
    }),
  }),
};

export default Cmv;
